module.exports = __webpack_public_path__ + "img/automatiza.4bcc2f2f.png";